import {cn} from '@bem-react/classname';

export const cnConfirmDialog = cn('ConfirmDialog');
